import repository from './repsitory'

const resource = '/productCategory'

export default {
    get () {
        return repository.get(`${resource}`)
    },
    getById (id) {
        return repository.get(`${resource}/${id}`)
    },
    getByIdForEdit (id) {
      return repository.get(`${resource}/edit/${id}`)
  },
    addProductCategory (data) {
        return repository.post(`${resource}`, data)
    },
    updateProductCategory (data, id) {
        return repository.put(`${resource}/${id}`, data)
    },
}
